// extracted by mini-css-extract-plugin
module.exports = {"offsetWrapper":"App_offsetWrapper__3t4eF","appBody":"App_appBody__3c5k0","contentWindow":"App_contentWindow__DickW","sidebar":"App_sidebar__1l9Om","noselect":"App_noselect__T_Z8U"};